<template>
  <div
    id="pageContent"
    ref="pageContent"
    :style="{height: (scrollBoxHeight + restHeight) +'px', overflowY: 'scroll', overflowX: 'hidden'}"
  >
    <van-pull-refresh
      v-if="pullRefresh"
      v-model="isLoading"
      loading-text="加载中..."
      success-text="刷新成功"
      @refresh="onRefresh"
    >
      <slot name="content" />
    </van-pull-refresh>
    <template v-else>
      <slot name="content" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'PageContent',
  props: {
    restHeight: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    pullRefresh: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  watch: {
    loading: {
      handler(val) {
        this.isLoading = val
      },
      immediate: true
    }
  },
  mounted() {
    const scrollView = this.$refs.pageContent
    scrollView.addEventListener('scroll', (e) => {
      const scrollTop = this.$refs.pageContent.scrollTop
      this.$emit('scroll', {
        scrollTop
      })
    }, true)
  },
  methods: {
    onRefresh() {
      this.$emit('onRefresh')
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .van-loading {
  text-align: center;
  padding-top: 30px;
}
::v-deep .van-pull-refresh__head {
  line-height: initial;
  height: initial;
  padding-bottom: 10px;
}
</style>
